import { AnyAction, applyMiddleware, compose, createStore, Dispatch, Middleware } from 'redux';
import thunk from 'redux-thunk';
import { devtoolsReduxEnhancer, sentryReduxEnhancer } from './enhancers';
import { rootReducer, IAppStateContainer } from './reducers';

export const actionToPlainObject: Middleware =
  () =>
  (next: Dispatch<AnyAction>) =>
  <A extends AnyAction>(action: A) =>
    next({ ...(action as object) } as A);

// We could import pre-hydrated data as the second param here
export const store = createStore<IAppStateContainer, AnyAction, any, any>(
  rootReducer,
  compose(applyMiddleware(thunk, actionToPlainObject), devtoolsReduxEnhancer, sentryReduxEnhancer)
);
